// FH1: form doğrulaması hata gösterince ilk hatalı alan ekranda değilse ona kaydırır.
// FormAlan (ve AdresAlani'nın harita uyarısı) hata metni boştan doluya geçince kaydirIste()
// çağırır; aynı turdaki çağrılar tek kaydırmada toplanır, hedef DOM'daki İLK hatalı alan.
// Hedef zaten görünüyorsa dokunulmaz (satır içi/canlı doğrulamada sayfa zıplamasın).
let bekliyor = false;

function gorunurMu(el) {
  const r = el.getBoundingClientRect();
  return r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

export function kaydirIste() {
  if (bekliyor) return;
  bekliyor = true;
  setTimeout(() => {
    bekliyor = false;
    const hata = document.querySelector("[data-form-hata]");
    if (!hata) return;
    const hedef = hata.closest("[data-form-alan]") || hata;
    if (gorunurMu(hedef)) return;
    hedef.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 0);
}
